export const ADMIN_IDS = ["93650e18-019e-4fde-ac0b-00afae082457"]